<template>
  <el-popover
    placement="top-start"
    width="250"
    trigger="hover"
  >
    <div v-loading="isBusy">
      <div
        class="pt-2 pb-0"
        style="font-weight: 600; font-size: 0.9em; color: rgba(0, 0, 0, 0.3)"
      >
        Module(s)
      </div>
      <div style="font-weight: 500; font-size: 0.9em">
        {{ event.data.course_unit_code }}
      </div>

      <div
        class="pt-2 pb-0"
        style="font-weight: 600; font-size: 0.9em; color: rgba(0, 0, 0, 0.3)"
      >
        Topic
      </div>
      <div style="font-weight: 500; font-size: 0.9em">
        {{ event.data.title == "N/A" ? "Topic N/A" : event.data.title }}
      </div>
      <div
        class="pt-2 pb-0"
        style="font-weight: 600; font-size: 0.9em; color: rgba(0, 0, 0, 0.3)"
      >
        Lecturer
      </div>
      <div style="font-weight: 500; font-size: 0.9em">
        {{ event.data.lecturer.first_name }}
        {{ event.data.lecturer.last_name }}
      </div>
      <div
        class="pt-2 pb-0"
        style="font-weight: 600; font-size: 0.9em; color: rgba(0, 0, 0, 0.3)"
      >
        Time
      </div>
      <div style="font-weight: 500; font-size: 0.9em">
        {{ formattedDate(event.data.date) }}
        <div style="font-size: 0.8em; color: rgba(0, 0, 0, 0.45)">
          {{ `${event.data.start_time} - ${event.data.end_time}` }}
        </div>
      </div>
      <div
        v-if="event.data.class_status && event.data.attendance_report.is_attended"
        class="pt-2 pb-0 text-center"
        style="
          font-weight: 600;
          font-size: 0.8em;
          color: rgba(61, 206, 60, 0.8);
        "
      >
        <i>You attended this Lecture</i>
      </div>
      <div
        v-else-if="event.data.class_status && !event.data.attendance_report.is_attended"
        class="pt-2 pb-0 text-center"
        style="
          font-weight: 600;
          font-size: 0.8em;
          color: rgba(255, 0, 0, 0.616);
        "
      >
        <i>You missed this Lecture</i>
      </div>

      <hr />

      <div
        @click="fetchLiveLectureUrl(event.data.live_lecture_id)"
        :class="{ disabled: isInFuture }"
        class="text-center"
        style="
          font-weight: 600;
          font-size: 0.9em;
          color: var(--el-app-primary);
          cursor: pointer;
          padding-bottom: 5px;
        "
      >
        {{
      isDateToday
        ? "ATTEND LECTURE"
        : isInFuture
          ? "NOT AVAILABLE"
          : "WATCH LECTURE"
    }}
      </div>
    </div>
    <div
      slot="reference"
      class="text-left w-100 event-item"
      style="
        font-size: 0.75em;
        background-color: #d7d7f3;
        border-radius: 8px 8px 0px 8px;
        position: relative;
        border: 1px solid rgba(170 170 245, 0.5);
      "
      :style="{
        backgroundColor: event.type == 'Lecture' ? '#d7d7f3' : '#FFD6C4',
        height: `${fractionalLength}px`,

        top: `${fractionalTopMarging}px`,
      }"
    >
      <i
        v-if="event.data.class_status && event.data.attendance_report.is_attended"
        class="el-icon-check color-green"
        style="font-size: 20px; position: absolute; right: 10px; top: 10px"
      ></i>
      <i
        v-else-if="event.data.class_status && !event.data.attendance_report.is_attended"
        class="el-icon-close color-red"
        style="font-size: 20px; position: absolute; right: 10px; top: 10px"
      ></i>
      <div
        class="pl-2 text-truncate"
        style="font-weight: 700; color: rgba(0, 0, 0, 0.75)"
        :style="{ paddingTop: `${fractionalTopPadding}px` }"
      >
        <div>
          {{ event.data.course_unit_code }}
        </div>
      </div>
      <div
        class="pl-2"
        style="font-weight: 700; color: rgba(0, 0, 0, 0.25)"
      >
        {{ event.type }}
      </div>
      <div
        class="pt-2 pl-2"
        style="font-weight: 700; color: rgba(0, 0, 0, 0.55); font-size: 0.73em"
      >
        <nobr> {{ `${event.data.start_time} - ${event.data.end_time}` }}</nobr>
      </div>
    </div>
  </el-popover>
</template>

<script>
import { format, parseISO, isAfter, isEqual } from "date-fns";
import { Popover } from "element-ui";
export default {
  components: {
    "el-popover": Popover,
  },
  data() {
    return {
      length: 70,
      isBusy: false,
    };
  },
  computed: {
    fractionalLength() {
      const hoursStart = this.event.data.start_time.substr(0, 2);
      const minutesStart = this.event.data.start_time.substr(3, 2);
      const modifierStart = this.event.data.start_time.substr(5, 2);

      const hoursEnd = this.event.data.end_time.substr(0, 2);
      const minutesEnd = this.event.data.end_time.substr(3, 2);
      const modifierEnd = this.event.data.end_time.substr(5, 2);

      var timeStart = new Date(
        `${this.event.data.date} ${hoursStart}:${minutesStart} ${modifierStart}`
      );
      var timeEnd = new Date(
        `${this.event.data.date} ${hoursEnd}:${minutesEnd} ${modifierEnd}`
      );

      var diff = (timeEnd - timeStart) / 60000; //dividing by seconds and milliseconds

      var minutes = diff % 60;
      var hours = (diff - minutes) / 60;

      return this.length * hours + (minutes / 60) * 70;
    },

    fractionalTopPadding() {
      if (this.fractionalLength == 70) return 8;
      return (this.fractionalLength - 70) * 0.55;
    },

    fractionalTopMarging() {
      const minutesStart = +this.event.data.start_time.substr(3, 2);
      console.log(this.event.data.start_time.substr(3, 2));
      return (minutesStart / 60) * this.length;
    },

    formattedDate() {
      return (dateString) => format(parseISO(dateString), "do MMMM yyyy");
    },

    isDateToday() {
      return isEqual(parseISO(this.event.data.date), parseISO(this.dateToday));
    },

    isInFuture() {
      return isAfter(parseISO(this.event.data.date), parseISO(this.dateToday));
    },
  },
  methods: {
    async fetchLiveLectureUrl(lectureId) {
      let request = await this.httpRequest({
        method: "GET",
        url: `live-lecture/get-student-class-url/by-live-lecture-id/${lectureId}`,
        loadingPropertyName: "isBusy",
        showSuccessMessage: false,
      });

      if (!request) return;

      if (
        request.success &&
        request.message == "LIVE CLASS URL RETRIEVED"
      ) {
        // Store the access token in the session storage
        sessionStorage.setItem("liveClassAccessToken", request.token);
        sessionStorage.setItem("liveClassRedirectUrl", this.$route.path);

        return this.$router.push("/ongoing-lecture");
        // window.location.href = request.lecture_link;
      } //Otherwise if its a google meet url
      else if (request.message === "Google Meet URL retrieved") {
        window.location.href = request.google_meet_url;
      }
    },
  },
  mounted() { },
  props: {
    event: {
      required: true,
      type: Object,
    },
    dateToday: {
      required: true,
      type: String,
    },
  },
};
</script>

<style scoped>
.event-item {
  cursor: pointer !important;
}

.disabled {
  color: rgba(0, 0, 0, 0.3) !important;
}

.color-red {
  color: red !important;
}

.color-green {
  color: rgb(7, 206, 7) !important;
}
</style>